import React from 'react';

import AboutPlaybookSection from '../AboutPlaybookSection/AboutPlaybookSection';
import PlaybookViewsSection from '../PlaybookViewsSection/PlaybookViewsSection';

const PlaybookSettingsTab = ({
    playbookDetail,
    setPlaybookDetail,
    isEditable,
    playbookViewsResponse,
}) => {
    const { id, is_shared } = playbookDetail;

    return (
        <div className="flex flex-col gap-5">
            <AboutPlaybookSection
                playbookDetail={playbookDetail}
                setPlaybookDetail={setPlaybookDetail}
                isEditable={isEditable}
            />

            {!is_shared && (
                <PlaybookViewsSection
                    playbookId={id}
                    playbookViewsResponse={playbookViewsResponse}
                />
            )}
        </div>
    );
};

export default PlaybookSettingsTab;
